import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class OnboardingListItem extends Component {
  static propTypes = {
    content: PropTypes.string.isRequired,
    actionTitle: PropTypes.string,
    onAction: PropTypes.any,
    id: PropTypes.string.isRequired,
  }
  render() {
    const { id, content, actionTitle, onAction } = this.props
    return(
      <div>
        {content}
        {actionTitle &&
          <button className="btn btn-clear pull-right" style={{padding: 10, color: 'inherit'}} onClick={() => onAction(id)}>
            {actionTitle}
          </button>
        }

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/components/OnboardingListItem.js